import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid, TableHead
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Select,
    Button,
    Divider,
    Table,
    TableBody,
    MenuItem,
    TableRow,
    TextField,
    TableCell,
    colors
} from '@material-ui/core';
import './Available_showroom.css';
import ReactHtmlParser from 'react-html-parser';
import { get_agency_showroom, get_showroom_by_agency } from '../../api/API';
import moment from 'moment/moment.js'

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

export default class Available_showrooms extends React.Component {

    constructor(props) {
        super(props);
        this.color_labeling = ['#cbfff740', 'rgba(139, 195, 74, 0.25)', '#dc747440'];
        this.state = {
            user_id: 0,
            showrooms: [],
            values: {
                showroom: null,
                date: moment(new Date()).format('YYYY-MM-DD')
            },
            slots: [

            ]
        };
    }

    componentDidMount() {
        this.setState({
            user_id: window.localStorage.getItem("user_id")
        }, () => {
            this.get_data();
        });

    }

    async get_data() {
        console.log("GETTING DATA");
        let data = await get_agency_showroom();
        this.setState({
            ...this.state,
            showrooms: data,
            values: {
                ...this.state.values,
                showroom: this.state.values.showroom == null && data.length > 0 ? data[0].property_id : this.state.values.showroom
            }
        }, async () => {
            this.setState({
                ...this.state,
                values: {
                    ...this.state.values
                }
            }, async () => {
                let showroom_data = await get_showroom_by_agency(this.state.values.showroom, this.state.values.date);
                if (showroom_data) {
                    this.format_data(showroom_data);

                }
            });

        });

        return true;
    }

    handleChange(e) {
        if (e.target.name == 'showroom') {
            for (var i = 0; i < this.state.showrooms.length; i++) {
                if (this.state.showrooms[i].property_id == e.target.value) {
                    this.setState({
                        ...this.state,
                        selected_showroom: this.state.showrooms
                    });
                }
            }

        }
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {

            console.log("state before get", this.state);
            this.get_data();
        });
    }

    format_data(data) {
        console.log(data);

        this.setState({ ...this.state, slots: data });
    }

    showBooking(booking, timeslot) {
        let current_id = window.localStorage.getItem("user_id");
        // for (let i = 0; i < data.length; i++) {
        // data[i]['formatted_slots'] = [];
        // for (let j = 0; j < data[i].slots; j++) {
        // if (j < data[i]['bookings'].length) {
        // data[i]['formatted_slots'].push({
        //     booking_id: data[i]['bookings'][j]['appointment_id'],
        //     status: data[i]['bookings'][j]['status'],
        //     is_mine: data[i]['bookings'][j]['agency_id'] == current_id,
        //     class: 'showroom_slot_item showroom_taken',
        //     event: () => {
        if (booking.agency_id == current_id) {
            this.props.infoAction(
                booking['appointment_id'],
                timeslot['max_pax'],
                timeslot,
                this.state.values.date
            )
        }
        //     }
        // });
    }
    createBooking(timeslot, max_pax) {
        let end_time = moment(this.state.values.date + " " + timeslot.end_time);
        let current_date = moment(new Date());

        if (end_time.isSameOrAfter(current_date)) {
            this.props.createAction(
                timeslot.timeslot_id,
                this.state.values.date,
                max_pax
            )
        } else {
            this.props.closeFormAction();
        }
    }

    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardHeader title="My Showrooms">
                        <TextField />
                    </CardHeader>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <Select
                                    fullWidth
                                    name="showroom"
                                    select
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.values.showroom}
                                    variant="outlined"
                                >
                                    {this.state.showrooms.map((showroom) => (
                                        <MenuItem
                                            key={showroom.property_id}
                                            value={showroom.property_id}
                                        >
                                            {showroom.property}
                                        </MenuItem>
                                    ))}

                                </Select>
                            </Grid>

                            <Grid item md={5}>
                                <TextField
                                    fullWidth
                                    name="date"
                                    type="date"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.values.date}
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                width: "100%"
                            }}
                        >
                            <br></br>
                            <div style={{
                                width: '100%',
                                marginBottom: 10,
                                display: 'flex',
                                justifyContent: "flex-end"
                            }}>
                                <label
                                    style={{
                                        marginRight: 20,
                                    }}
                                >Legend :</label>

                                <div style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 10,
                                    backgroundColor: "#42a5f5"
                                }}></div>
                                <label
                                    style={{
                                        marginRight: 20,
                                    }}
                                >booked</label>

                                <div style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 10,
                                    backgroundColor: "#66bb6a"
                                }}></div>
                                <label
                                    style={{
                                        marginRight: 20,
                                    }}
                                >arrived</label>
                                <div style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 10,
                                    backgroundColor: "#bdbdbd"
                                }}></div>
                                <label style={{
                                    marginRight: 20,
                                }}
                                >no show</label>

                            </div>
                        </div>


                        {this.state.slots.map(timeslot => (
                            <>
                                {timeslot.type == '1' ?
                                    (
                                        <React.Fragment key={timeslot.timeslot_id} >
                                            <Grid container className="agency_card_container">
                                                <div className="agency_wrapper">
                                                    <div className="agency">
                                                        {moment('2020-02-02 ' + timeslot.start_time).format("h:mm A")} - {moment('2020-02-02 ' + timeslot.end_time).format("h:mm A")}

                                                        <p className="leftover">{timeslot.slots - timeslot.total} available</p>
                                                    </div>
                                                    <div className="agency_booking_wrapper">
                                                        {timeslot.bookings.map((booking) => (
                                                            <React.Fragment>
                                                                <div className="agency_booking"
                                                                    onClick={((e) => {
                                                                        if (timeslot.type == '2') {
                                                                            if (window.localStorage.getItem('role') == 'agent') {
                                                                                console.log("1");
                                                                                if (booking.agency_id != window.localStorage.getItem("agency_id")) {
                                                                                    return;
                                                                                }
                                                                            } else {
                                                                                console.log("HERE");
                                                                                if (booking.is_self != '1') {
                                                                                    return;
                                                                                }
                                                                            }

                                                                        }
                                                                        this.props.infoAction(
                                                                            booking.appointment_id,
                                                                            timeslot.max_pax,
                                                                            timeslot,
                                                                            this.state.values.date
                                                                        )


                                                                    }).bind(this)}
                                                                >
                                                                    <div className={"status_icon " + "status_" + booking.status}></div>
                                                                    <p>{booking.agent_name}</p>
                                                                    <p>{booking.agent_contact}</p>
                                                                    <p className="pax">Agents: {booking.agent_pax} Guests: {booking.pax}</p>
                                                                </div>
                                                            </React.Fragment>
                                                        ))}
                                                        {
                                                            (timeslot.slots - timeslot.total) > 0 && (
                                                                <div className="agency_booking" style={{
                                                                    borderTop: 'none'
                                                                }}
                                                                    onClick={() => {
                                                                        this.createBooking(timeslot, timeslot.max_pax)
                                                                    }}

                                                                >
                                                                    <span className="plus">+</span>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </Grid>
                                            <br></br>
                                            <hr style={{
                                                borderWidth: 0,
                                                borderTop: "1px solid rgb(222 222 222)"
                                            }}></hr>
                                            <br></br>
                                        </React.Fragment>

                                    ) :

                                    (<React.Fragment key={timeslot.timeslot_id} >
                                        <Grid container className="agency_card_container">
                                            <div className="agency_wrapper">
                                                <div className="agency">
                                                    {moment('2020-02-02 ' + timeslot.start_time).format("h:mm A")} - {moment('2020-02-02 ' + timeslot.end_time).format("h:mm A")}

                                                    <p className="leftover">{timeslot.slots - timeslot.total} available</p>
                                                </div>
                                                <div className="agency_booking_wrapper">
                                                    {timeslot.bookings.map((booking) => (
                                                        <>
                                                            {
                                                                (
                                                                    (window.localStorage.getItem("role") != 'agent' && booking.is_self == "1")
                                                                    || (window.localStorage.getItem("role") == "agent" && booking.agency_id == window.localStorage.getItem("agency_id"))
                                                                    )

                                                                    && (
                                                                        <React.Fragment>
                                                                            <div className="agency_booking"
                                                                                onClick={((e) => {
                                                                                    if (timeslot.type == '2') {
                                                                                        if (booking.is_self != '1') {
                                                                                            return;
                                                                                        }
                                                                                    }
                                                                                    this.props.infoAction(
                                                                                        booking.appointment_id,
                                                                                        timeslot.max_pax,
                                                                                        timeslot,
                                                                                        this.state.values.date
                                                                                    )


                                                                                }).bind(this)}
                                                                            >
                                                                                <div className={"status_icon " + "status_" + booking.status}></div>
                                                                                <p>{booking.agent_name}</p>
                                                                                <p>{booking.agent_contact}</p>
                                                                                <p className="pax">Agents: {booking.agent_pax} Guests: {booking.pax}</p>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                            }
                                                        </>
                                                    ))}
                                                    {
                                                        (timeslot.slots - timeslot.bookings.length) > 0 && (
                                                            <div className="agency_booking" style={{
                                                                borderTop: 'none'
                                                            }}
                                                                onClick={() => {
                                                                    this.createBooking(timeslot, timeslot.max_pax)
                                                                }}

                                                            >
                                                                <span className="plus">+</span>
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        </Grid>
                                        <br></br>
                                        <hr style={{
                                            borderWidth: 0,
                                            borderTop: "1px solid rgb(222 222 222)"
                                        }}></hr>
                                        <br></br>
                                    </React.Fragment>)}
                            </>

                        ))}
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

} 
